"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.APIUtils = exports.APIRegistry = void 0;

var _registry = _interopRequireDefault(require("./registry"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var APIRegistry = new _registry.default();
exports.APIRegistry = APIRegistry;
var APIUtils = APIRegistry.get('default');
exports.APIUtils = APIUtils;
var _default = APIUtils;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(APIRegistry, "APIRegistry", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/api/api.js");
  reactHotLoader.register(APIUtils, "APIUtils", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/api/api.js");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-utils/src/api/api.js");
  leaveModule(module);
})();

;